import { Tag } from 'antd';
import { memo } from 'react';
import { Icon, Image } from 'semantic-ui-react';

import styles from './DraggableImage.module.css';
import { Draggable, DraggableProvided } from 'react-beautiful-dnd';

interface DraggableImageProps {
  id: string;
  url: string;
  index: number;
  isBeingDeleted: boolean;
  showRepresentativeTag: boolean;
  tryDeleteImage: () => void;
  openImageGallery: () => void;
}

function DraggableImage({
  id,
  url,
  index,
  isBeingDeleted,
  tryDeleteImage,
  openImageGallery,
  showRepresentativeTag,
}: DraggableImageProps) {
  return (
    <Draggable key={id} draggableId={id} index={index}>
      {(dragProvided: DraggableProvided) => (
        <div
          ref={dragProvided.innerRef}
          className={styles.container}
          {...dragProvided.draggableProps}
          {...dragProvided.dragHandleProps}
        >
          <div className={styles.image} onClick={openImageGallery}>
            <Image src={url} disabled={isBeingDeleted} />
          </div>
          <Icon
            className={styles.delete}
            name={isBeingDeleted ? 'spinner' : 'delete'}
            circular
            inverted
            loading={isBeingDeleted}
            color="black"
            onClick={tryDeleteImage}
          />
          {showRepresentativeTag && (
            <Tag className={styles.ribbon} color="magenta">
              대표
            </Tag>
          )}
        </div>
      )}
    </Draggable>
  );
}

export default memo(DraggableImage);
